// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type CreateEpmMasterAllocationKeyMutationVariables = Types.Exact<{
  input: Types.CreateEpmMasterAllocationKeyInput;
}>;

export type CreateEpmMasterAllocationKeyMutation = { __typename?: 'Mutation' } & {
  createEpmMasterAllocationKey: { __typename?: 'EpmMasterAllocationKeyOutput' } & Pick<
    Types.EpmMasterAllocationKeyOutput,
    'id'
  >;
};

export const CreateEpmMasterAllocationKeyDocument = /*#__PURE__*/ gql`
    mutation createEpmMasterAllocationKey($input: CreateEpmMasterAllocationKeyInput!) {
  createEpmMasterAllocationKey(input: $input) {
    id
  }
}
    `;
export type CreateEpmMasterAllocationKeyMutationFn = Apollo.MutationFunction<
  CreateEpmMasterAllocationKeyMutation,
  CreateEpmMasterAllocationKeyMutationVariables
>;

/**
 * __useCreateEpmMasterAllocationKeyMutation__
 *
 * To run a mutation, you first call `useCreateEpmMasterAllocationKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEpmMasterAllocationKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEpmMasterAllocationKeyMutation, { data, loading, error }] = useCreateEpmMasterAllocationKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEpmMasterAllocationKeyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateEpmMasterAllocationKeyMutation,
    CreateEpmMasterAllocationKeyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateEpmMasterAllocationKeyMutation, CreateEpmMasterAllocationKeyMutationVariables>(
    CreateEpmMasterAllocationKeyDocument,
    options,
  );
}
export type CreateEpmMasterAllocationKeyMutationHookResult = ReturnType<typeof useCreateEpmMasterAllocationKeyMutation>;
export type CreateEpmMasterAllocationKeyMutationOptions = Apollo.BaseMutationOptions<
  CreateEpmMasterAllocationKeyMutation,
  CreateEpmMasterAllocationKeyMutationVariables
>;
